import React from "react";
import { Modal } from "antd";
import styles from "./index.module.scss";
import { useModalStore } from "@/store/modle";
import warning from "@/assets/images/chainWarning.svg";
import close from "@/assets/images/close.svg";
import { LoadingOutlined } from "@ant-design/icons";
import { getChainInfoById } from "@/constants/const";
import { targetChainId } from "./StakeModal";

export default function ChainSwitchModal({
  switchFunc,
  switchLoading,
}: {
  switchFunc: () => void;
  switchLoading: boolean;
}) {
  const setShowChainSwitchWarningModal = useModalStore(
    (state) => state.setShowChainSwitchWarningModal
  );
  const showChainSwitchWarningModal = useModalStore(
    (state) => state.showChainSwitchWarningModal
  );
  return (
    <Modal
      closable
      open={showChainSwitchWarningModal}
      width={460}
      centered
      destroyOnHidden
      title={null}
      onCancel={() => {
        setShowChainSwitchWarningModal(false);
      }}
      footer={null}
      maskClosable={false}
      className={styles.commonModal}
      closeIcon={<img src={close} alt="logo" width={24} height={24} />}
    >
      <img
        src={warning}
        alt="chainSwitchWarning"
        width={80}
        height={80}
        style={{ marginTop: 0 }}
        className={styles.commonImg}
      />
      <div className={styles.commonDes}>
        Please Switch to {getChainInfoById(targetChainId).chainName}.
      </div>
      <div className={styles.commonBtn} onClick={() => switchFunc()}>
        Switch to {getChainInfoById(targetChainId).chainName}
        {switchLoading && <LoadingOutlined style={{ marginLeft: 5 }} />}
      </div>
    </Modal>
  );
}
